import React from 'react';
import classnames from 'classnames';
import dateFormat from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { formatPrice, changeDecimalTo } from 'utils/';
import { DEFAULT_CURRENCY } from 'constants/index';
import { translate } from 'constants/language';

export default ({ transDetails = {}, wrapperClasses = '', isHead }) => {
  const {
    type = '',
    date = '',
    charge = '',
    balance = '',
    isCredit = false
  } = transDetails;
  return (
    <div
      className={classnames(
        wrapperClasses,
        'row pt-8 pb-8 fs-12 lh-16 c-brown-gray'
      )}
    >
      <div
        className={classnames('col-xs-4 c-dark-gray', {
          'en-font': !!type && !isHead
        })}
      >
        {type ? `${isHead ? '' : '#'}` : translate('Customer Care')}
        {type}
      </div>
      <div
        className={classnames('col-xs-2', {
          'en-font': !isHead
        })}
      >
        {isHead
          ? translate('Date')
          : dateFormat(new Date(parseISO(date)), 'dd/MM/yy')}
      </div>
      {/* <div className="col-xs-3">{parseISO(date)}</div> */}
      <div
        className={classnames('col-xs-3', {
          'c-secondary-negative': !isHead && !isCredit,
          'c-sap-green': !isHead && isCredit,
          'en-font': !isHead
        })}
      >
        <If condition={!isHead}>{isCredit ? '+' : '-'}</If>
        {isHead
          ? translate('Change')
          : formatPrice(changeDecimalTo(charge, 2), null, {
              DEFAULT_CURRENCY,
              maximumFractionDigits: 2,
              minimumFractionDigits: 2
            }).replace(`${DEFAULT_CURRENCY}`, '')}
        {isHead ? '' : ` ${DEFAULT_CURRENCY}`}
      </div>
      <div
        className={classnames('col-xs-3 ', {
          'fw-6 c-dark-gray en-font': !isHead
        })}
      >
        {isHead
          ? translate('Balance')
          : formatPrice(changeDecimalTo(balance, 2), null, {
              DEFAULT_CURRENCY,
              maximumFractionDigits: 2,
              minimumFractionDigits: 2
            }).replace(`${DEFAULT_CURRENCY}`, '')}
        {isHead ? '' : ` ${DEFAULT_CURRENCY}`}
      </div>
    </div>
  );
};
